/* Keyboard access for the existing desktop department toggle. Mobile navigation is untouched. */
(function () {
  'use strict';
  document.querySelectorAll('.header-container.style-2 .vertical-menu .head').forEach(function (head) {
    head.setAttribute('role', 'button');
    head.setAttribute('tabindex', '0');
    function reflectState() {
      var menu = head.closest('.vertical-menu').querySelector('.vertical-navbar');
      head.setAttribute('aria-expanded', menu && menu.classList.contains('opened') ? 'true' : 'false');
    }
    reflectState();
    head.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); head.click(); }
    });
    head.addEventListener('click', function () { window.setTimeout(reflectState, 0); });
  });
})();
